import type { FaireProductEntity } from "../../entity_types/product";

export const p_72ve07uh3w: FaireProductEntity = {
  token: "p_72ve07uh3w",
  type: "product",
  name: "Baby's First Christmas 2025 Ornament with Ribbon and Box",
  brandToken: "b_191br80oqs",
  brandName: "The Cotton & Canvas Co.",
  imageUrl: "https://cdn.faire.com/fastly/131b199c22972c8fc42a3911c40b8374b8ac0a56539ec22dc12604c9fed0c782.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dfba015dc596a457b015e13168b00add3e4738a5496e1f5854a00520507a7cdd.jpeg",
    "https://cdn.faire.com/fastly/252ae215b58479ee275bf716f9eb96166c9785fb48ad20fe41d4a070872085b6.jpeg",
    "https://cdn.faire.com/fastly/c121f775c0c119334ec9659b89e5a28b2eed88a7bf51ee1c41a461596af47736.jpeg"
  ],
  priceDollars: 7.5,
  description: "Our Christmas ornaments make the cutest gifts for the holidays. Printed on high quality, ceramic material, these ornaments add an elegant touch to your Christmas décor! Each ornament features a unique design printed with vibrant inks. The designs are permanently pressed directly onto the Christmas ornament, creating an everlasting image that will not peel off or fade. Measures 2.75\" in diameter. Includes a complimentary gift box - perfect for gift giving!",
  tags: [],
  msrpDollars: 14.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:03:45.743Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
